import moment from "moment";

export const formatDate = (dateString: string): string => moment(dateString).fromNow()
